import { useEffect, useState } from 'react';
import { getAllConditions, getPersonalHistory, postCondition, postCopyCondition, putPersonalHistory } from '../../../api/medicalRecord';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';

export const useConditions = (medicalRecordNumber, entryId, category, actual = true, isChronic = null) => {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        medicalRecordNumber: medicalRecordNumber ? medicalRecordNumber : 0,
        entryId: entryId ? entryId : 0,
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        },
        category,
        filters: { isChronic, category, actual, searchTerm: '' }
    });
    const [reload, setReload] = useState(false);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setReload(false);
                setIsLoading(true);
                const paginatedItems = await getAllConditions(query);

                if (isSubscribed) {
                    setTotalSize(paginatedItems.data.count);
                    setData(paginatedItems.data.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setTotalSize(0);
                setData([]);
            }
        }

        fetchData();

        return () => isSubscribed = false;
    }, [query, reload]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        var newQuery = JSON.parse(JSON.stringify(query));

        switch (type) {
            case 'pagination': {
                newQuery.pagination.page = page;
                newQuery.pagination.sizePerPage = sizePerPage;
                setQuery(newQuery);
                break;
            }
            case 'sort': {
                newQuery.sort.sortField = sortField;
                newQuery.sort.sortOrder = sortOrder;
                setQuery(newQuery);
                break;
            }
            default: break;
        }
    }

    const setSearchTerm = (searchTerm) => {
        setQuery(prev => ({
            ...prev,
            filters: { ...prev.filters, searchTerm },
            pagination: { ...prev.pagination, page: 1 }
        }));
    }

    return [data, query, totalSize, isLoading, handleTableChange, setReload, setSearchTerm];
}

export const useCondition = (entryId, id) => {

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const res = await getPersonalHistory(entryId, id);

                if (isSubscribed) {
                    setData(res.data);
                    setIsLoading(false);
                }

            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setData(null);
            }
        }

        if (id)
            fetchData();

        return () => isSubscribed = false;
    }, [entryId, id]);

    const create = (entryId, data, category) => {
        return postCondition(entryId, data, category);
    }

    const update = (entryId, id, data) => {
        return putPersonalHistory(entryId, id, data);
    }

    const copy = (entryId, id, data) => {
        return postCopyCondition(entryId, id, data);
    }

    return [data, isLoading, create, update, copy];
}